import Splide from '@splidejs/splide';

// MV（記事毎スライダー）— 画像をスライドし、左の見出し/抜粋をアクティブスライドと同期
const initCasesMv = () => {
  const root = document.querySelector('.js-mv-slider');
  if (!root) return;

  const splide = new Splide(root, {
    type: 'loop',
    perPage: 1,
    gap: '24px',
    arrows: false,
    pagination: true,
    mediaQuery: 'min',
    breakpoints: {
      1025: {
        fixedWidth: '665px',
        pagination: false,
      },
    },
  });

  const titleEl = document.querySelector('.js-mv-title');
  const excerptEl = document.querySelector('.js-mv-excerpt');

  const sync = () => {
    const slides = root.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
    const slide = slides[splide.index];
    if (!slide) return;
    if (titleEl && slide.dataset.title) titleEl.textContent = slide.dataset.title;
    if (excerptEl && slide.dataset.excerpt) excerptEl.textContent = slide.dataset.excerpt;
  };

  // SPではページネーションを抜粋の下（MV最下部）に表示するため、
  // Splideが生成した .splide__pagination を __mv 直下へ移動する
  const mv = root.closest('.p-cases__mv');
  splide.on('pagination:mounted', (data) => {
    if (mv && data.list) mv.appendChild(data.list);
  });

  splide.on('mounted move', sync);
  splide.mount();

  const prev = document.querySelector('.js-mv-prev');
  const next = document.querySelector('.js-mv-next');
  if (prev) prev.addEventListener('click', () => splide.go('<'));
  if (next) next.addEventListener('click', () => splide.go('>'));
};

// 記事一覧 — 無限スクロール（9件ずつ追加）＋絞り込みの非同期更新
const initCasesList = () => {
  const grid = document.querySelector('.js-cases-grid');
  if (!grid || typeof window.lstepCases === 'undefined') return;

  const loader = document.querySelector('.js-cases-loader');
  const sentinel = document.querySelector('.js-cases-sentinel');
  const filter = document.querySelector('.js-cases-filter');
  const countEl = document.querySelector('.js-cases-count');
  const filterCountEl = document.querySelector('.js-filter-count');

  let page = parseInt(grid.dataset.page, 10) || 1;
  let maxPages = parseInt(grid.dataset.maxPages, 10) || 1;
  let loading = false;
  let requestId = 0;

  const getChecked = (name) => {
    if (!filter) return [];
    return Array.from(filter.querySelectorAll(`input[name="${name}[]"]:checked`)).map((input) => input.value);
  };

  const fetchPosts = async (nextPage, append) => {
    loading = true;
    requestId += 1;
    const currentRequest = requestId;
    if (loader) loader.classList.add('is-visible');

    const body = new FormData();
    body.append('action', 'lstep_filter_cases');
    body.append('nonce', window.lstepCases.nonce);
    body.append('page', nextPage);
    getChecked('purpose').forEach((v) => body.append('cats[]', v));
    getChecked('industry').forEach((v) => body.append('tags[]', v));

    try {
      const res = await fetch(window.lstepCases.ajaxUrl, { method: 'POST', body });
      const json = await res.json();
      // 古いリクエストの結果は破棄（絞り込み連打対策）
      if (currentRequest !== requestId || !json.success) return;

      const data = json.data;
      if (append) {
        grid.insertAdjacentHTML('beforeend', data.html);
      } else {
        grid.innerHTML = data.html;
      }
      page = data.page;
      maxPages = data.maxPages;
      if (countEl) countEl.textContent = data.found;
      if (filterCountEl) filterCountEl.textContent = data.found;
    } catch (e) {
      // 通信失敗時は現状維持
    } finally {
      if (currentRequest === requestId) {
        loading = false;
        if (loader) loader.classList.remove('is-visible');
      }
    }
  };

  // 下までスクロールされたら次の9件を読み込む
  if (sentinel) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !loading && page < maxPages) {
            fetchPosts(page + 1, true);
          }
        });
      },
      { rootMargin: '300px 0px' }
    );
    observer.observe(sentinel);
  }

  // チェック変更で一覧をリセットして再取得
  if (filter) {
    filter.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', () => fetchPosts(1, false));
    });
  }

  // 条件リセット（チェック解除は initCasesFilter 側で実行済み）
  const resetBtn = document.querySelector('.js-filter-reset');
  if (resetBtn) resetBtn.addEventListener('click', () => fetchPosts(1, false));
};

// SP 絞り込みポップアップ
const initCasesFilter = () => {
  const fab = document.querySelector('.js-filter-toggle');
  const filter = document.querySelector('.js-cases-filter');
  if (!fab || !filter) return;

  const overlay = document.querySelector('.js-filter-overlay');
  const closeBtn = document.querySelector('.js-filter-close');
  const resetBtn = document.querySelector('.js-filter-reset');

  const open = () => {
    filter.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('is-filter-open');
  };

  const close = () => {
    filter.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('is-filter-open');
  };

  fab.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);
  if (resetBtn) {
    resetBtn.addEventListener('click', () => {
      filter.querySelectorAll('input[type="checkbox"]').forEach((c) => {
        c.checked = false;
      });
    });
  }
};

const initCases = () => {
  initCasesMv();
  initCasesFilter();
  // リセットボタンのチェック解除（initCasesFilter）より後に登録する
  initCasesList();
};

export default initCases;
